import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import {Panel} from 'components';
import OptionalCoverageEnrolment from './OptionalCoverageEnrolment';

const OptionalCoveragesListForCarrier = observer(({uiState, carrierName}) => {
  const {errors} = uiState;
  const optionalCoverageEnrolments = uiState.optionalCoverageEnrolmentsFor(carrierName);

  if (!optionalCoverageEnrolments.length) return null;

  return (
    <div className='border rounded mb2'>
      <div className='pt2 px2 bg-haze'>
        <Panel.Subheader title={carrierName}/>
      </div>
      <div className='border-top bg-white pt2 px2'>
        {optionalCoverageEnrolments.map((optionalEnrolment, index) =>
          <OptionalCoverageEnrolment
            key={optionalEnrolment.groupBenefitCoverageId}
            uiState={uiState}
            enrolment={optionalEnrolment}
            errorMessage={_.get(errors, `optionalCoverageEnrolments[${index}].cost`)}/>
        )}
      </div>
    </div>
  );
});

export default OptionalCoveragesListForCarrier;
